module.exports = __webpack_public_path__ + "static/app1-e87bff8140a60766147c37b8377e944a.png";